import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

import type { Account } from "./use-connected-accounts-query";

type Params = {
  name: string;
  type: "google" | "icloud";
};

export const useDeleteAccountMutation = () => {
  const queryClient = useQueryClient();
  const fetch = useAuthFetch();
  return useMutation({
    mutationFn: async (params: Params) => {
      console.log(params);
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/connected-account`,
        {
          method: "DELETE",
          body: JSON.stringify({
            ...params,
          }),
        }
      );

      const result: {
        connected_accounts: Account[];
        id: string;
      } = await response.json();

      return result;
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: ["api", "connected-accounts"],
      });
    },
  });
};
